import { TextField } from "@material-ui/core";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import UniDialog from "../../../Common/UniDialog";



function TransshipmentDialog(props){
    const {open, onClose, onFinish} = props;
    const {t} = useTranslation('editOrder');

    const [transshipmentNo, setTransshipmentNo] = useState("")

    return (
        <UniDialog
            title={t('dialog_transshipment_title')}
            maxWidth='xs'
            fullWidth
            open={open}
            onClose={()=>{
                onClose()
                setTransshipmentNo("")
            }}
            autoClose={false}
            onFinish={()=>{
                submit(validateValue(transshipmentNo))
            }}
            contentStyle={{overflow: 'hidden'}}
        >
            <TextField
                autoFocus
                label={t('transshipment_no')}
                variant='outlined'
                fullWidth
                error={transshipmentNo.length <= 0}
                helperText={transshipmentNo.length <= 0 ? t('common:input_cannot_be_empty'): null}
                onChange={(event)=>{setTransshipmentNo(event.target.value.trim())}}
            />
        </UniDialog>
    )

    function submit(value){
        if(value === null){
            return 
        }
        onFinish(value)
        onClose()
    }

    function validateValue(value){
        if(value.length <= 0){
            return null
        }
        return value
    }
}

export default TransshipmentDialog